import React from "react";
import useZibi from "../../zibi/UseZibi";
import Placement from "./Placement";
import PlanogramDisplay from "./planogram-display";

import { AlertCircle, CheckCircle } from "lucide-react";

const ShelfView = ({ shelf, sensor, products, productsCount }) => {
  const {
    planogram = [],
    sensorId,
    weightMismatchPlanogram,
    name,
    width,
    height,
  } = shelf; // added width and height from shelf

  const { placements = [], boardId, alerts = [] } = sensor[0] || {};
  const [productsById, set_productsById] = useZibi("productsById");

  const numberOfProductsOnShelf = countNumberOfProductsOnShelf(placements);
  const numberOfProductsOnPlanogram =
    countNumberOfProductsOnPlanogram(planogram);
  // Extract zero line regions
  const zeroLineRegions =
    alerts.find((alert) => alert.eventSubType === "ZERO_LINE")?.data?.details
      ?.regions || [];
  const reloadShelf =
    alerts.find((alert) => alert.eventSubType === "RELOAD_SHELF")?.data?.details
      ?.reloadItems || [];

  // Check for missing placements
  const missingRegions = zeroLineRegions.filter((region) => {
    const isPlacementInRegion = placements.some(
      (placement) =>
        placement.start_pr >= region.start_pr &&
        placement.start_pr < region.end_pr
    );
    return !isPlacementInRegion; // Region is missing placements
  });
  if (missingRegions) {
    // debugger;
  }
  const Alert = ({ type, message }) => {
    const alertStyles = {
      reload: "bg-blue-500",
      fifo: "bg-yellow-500",
      frontFacing: "bg-green-500",
      planogram_not_configured: "bg-cyan-400",
      planogram_not_valid: "bg-red-400", //missed placed product
      reload_shelf: "bg-red-500",
      weight_mismatch: "hidden",
      zero_line: "bg-amber-400",
    };

    const icons = {
      reload: <AlertCircle size={20} />,
      fifo: <AlertCircle size={20} />,
      frontFacing: <CheckCircle size={20} />,
      planogram_not_configured: <CheckCircle size={20} />,
      planogram_not_valid: <CheckCircle size={20} />,
      reload_shelf: <CheckCircle size={20} />,
      weight_mismatch: <CheckCircle size={20} />,
      zero_line: <CheckCircle size={20} />,
    };

    return (
      <div
        className={`flex items-left space-x-1 ${alertStyles[type]} text-white text-sm px-4 py-2  `}
      >
        {icons[type]}
        <span className="font-semibold">{message} </span>
      </div>
    );
  };

  return (
    <div className="flex flex-col  ">
      <div
        className="p-1 w-full bg-fuchsia-800 rounded-s col-span-2"
        // style={{ height: "50px" }}
      >
        <h2
          className="flex items-center space-x-3 text-white	text-xl font-extrabold	
"
        >
          {boardId}
          <div className="flex items-right space-x-3">
            {alerts.map((alert, idx) => (
              // console.log(alert.eventSubType?.toLowerCase() || "default"),
              // console.log("alert", alert),
              <Alert
                key={idx}
                type={alert.eventSubType?.toLowerCase() || "default"}
                message={
                  alert.eventSubType === "PLANOGRAM_NOT_CONFIGURED"
                    ? "Planogram not configured"
                    : alert.eventSubType === "PLANOGRAM_NOT_VALID"
                    ? "Missedplace product"
                    : alert.eventSubType === "LOW_INVENTORY"
                    ? "Low inventory"
                    : alert.eventSubType === "ZERO_LINE"
                    ? "Front line"
                    : alert.eventSubType === "RELOAD_SHELF"
                    ? "Reload shelf"
                    : alert.eventSubType === "DURATION_EXCEEDED"
                    ? "Duration exceeded"
                    : alert.eventSubType === "FIFO"
                    ? "FIFO"
                    : // : alert.eventSubType === "WEIGHT_MISMATCH"
                      // ? "Weight mismatch"
                      "General Alert"
                }
              />
            ))}
          </div>
        </h2>
      </div>

      <div className="grid grid-rows-1 grid-flow-col gap-1 px-4 py-4 leading-10 ">
        <div className="p-4 w-full bg-fuchsia-600 rounded-s row-span-3 bg-gradient-to-br from-stone-200 to-gray-300 w-1/4">
          <div
            className="relative"
            style={{
              width: width || "400px",
              height: height || "160px",
              backgroundColor: "#f4f4f4",
              boxSizing: "border-box",
            }}
          >
            {zeroLineRegions.map((region, index) => {
              const left = `${region.start_pr}%`;
              const width = `${region.end_pr - region.start_pr}%`;
              const height = "10px";
              const top = "150px";

              const isMissing = missingRegions.some(
                (missing) =>
                  missing.start_pr === region.start_pr &&
                  missing.end_pr === region.end_pr
              );

              return (
                <div
                  key={index}
                  className={`absolute top-0 h-full ${
                    isMissing
                      ? "bg-red-500 bg-opacity-50"
                      : "bg-green-500 bg-opacity-20"
                  }`}
                  style={{ left, width, height, top }}
                  title={
                    isMissing
                      ? `Missing placement: ${region.start_pr}% - ${region.end_pr}%`
                      : `Placement present: ${region.start_pr}% - ${region.end_pr}%`
                  }
                />
              );
            })}

            {placements.map((placement, index) => (
              <Placement
                products={products}
                item={placement}
                key={index}
                alerts={alerts}
              />
            ))}
          </div>
          &nbsp;
        </div>

        <div className="p-5 w-full bg-fuchsia-700 rounded-s row-span-2 col-span-2">
          <div className="flex flex-nowrap gap-1">
            {planogram.map((item, index) => {
              return (
                <PlanogramDisplay
                  key={index}
                  planogram={item}
                  numberOfProductsOnShelf={numberOfProductsOnShelf}
                  numberOfProductsOnPlanogram={numberOfProductsOnPlanogram}
                  productsCount={productsCount}
                  alerts={reloadShelf}
                />

                // <div
                //   key={index}
                //   id={planogram.length}
                //   className={`flex flex-col border rounded-lg shadow p-4 bg-white w-1/6`}
                // >
                //   <div className="flex items-start	">
                //     <img
                //       src={item.product.imageUrl}
                //       alt={item.product.name}
                //       className=" w-20 h-80 mr-4"
                //       style={{ objectFit: "cover", height: "80px" }}
                //     />
                //   </div>
                //   <p className="text-l font-black	text-center		">
                //     {" "}
                //     {numberOfProductsOnShelf[item.productId] ?? 0}/
                //     {numberOfProductsOnPlanogram[item.productId]}
                //   </p>
                //   <p></p>
                //   <p className="text-xl/[36px] font-black text-center		">
                //     {productsCount[item.productId] ?? 0}
                //     {/* {numberOfProductsOnPlanogram}/ */}
                //   </p>
                //   {/* {item.productId} */}
                // </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>

    // <div className="bg-white/90 rounded-xl p-1 shadow-xl backdrop-blur-sm ">
    //   <div className="flex items-center justify-between mb-4">
    //     <div className="flex items-center space-x-3">
    //       <span className="text-sm font-bold text-gray-800">{boardId}</span>
    //       {alerts.map(
    //         (alert, idx) => (
    //           console.log(alert.eventSubType?.toLowerCase() || "default"),
    //           (
    //             <Alert
    //               key={idx}
    //               type={alert.eventSubType?.toLowerCase() || "default"}
    //               message={
    //                 alert.eventSubType === "PLANOGRAM_NOT_CONFIGURED"
    //                   ? "Planogram not configured"
    //                   : alert.eventSubType === "PLANOGRAM_NOT_VALID"
    //                   ? "Planogram not valid"
    //                   : alert.eventSubType === "LOW_INVENTORY"
    //                   ? "Low inventory"
    //                   : alert.eventSubType === "ZERO_LINE"
    //                   ? "Zero line"
    //                   : alert.eventSubType === "RELOAD_SHELF"
    //                   ? "Reload shelf"
    //                   : alert.eventSubType === "DURATION_EXCEEDED"
    //                   ? "Duration exceeded"
    //                   : alert.eventSubType === "FIFO"
    //                   ? "  FIFO"
    //                   : alert.eventSubType === "WEIGHT_MISMATCH"
    //                   ? "Weight mismatch"
    //                   : "General Alert"
    //               }
    //             />
    //           )
    //         )
    //       )}
    //     </div>
    //   </div>

    //   <div className="grid grid-cols-1 gap-4 md:grid-cols-2 ">
    //     <div className="bg-gray-50 p-4 rounded-xl relative bg-gradient-to-r from-blue-500 to-purple-500 ">
    //       <div className="grid grid-cols-1 gap-2 sm:grid-cols-3 md:grid-cols-1 ">
    //         {/* Shelf Regions for Zero Line Alerts */}

    //         {/* Placements */}
    //         <div
    //           className="relative"
    //           style={{
    //             width: width || "400px",
    //             height: height || "160px",
    //             backgroundColor: "#ff0",
    //           }}
    //         >
    //           {placements.map((placement, index) => (
    //             <Placement products={products} item={placement} key={index} />
    //           ))}
    //         </div>
    //       </div>
    //     </div>

    //     <div className="bg-gray-50 p-4 rounded-xl">
    //       <div className="grid grid-cols-1 md:grid-cols-5">
    //         {planogram.map((item, index) => (
    //           <div
    //             key={index}
    //             className="w-20 h-20 bg-gray-200 relative flex flex-col items-left justify-left rounded-lg text-center text-sm font-bold p-1"
    //           >
    //             {/* Container for Image and Name (side by side) */}
    //             <div className="flex items-center justify-start space-x-2 w-full">
    //               {/* Image */}
    //               <img
    //                 src={item.product.imageUrl}
    //                 alt={item.product.name}
    //                 className="h-16 w-16 object-cover rounded-lg"
    //               />

    //               {/* Product Name */}
    //               <div className="text-gray-600 text-xs max-w-[calc(100%-3rem)] overflow-hidden text-ellipsis">
    //                 <span>{item.product.name}</span>
    //               </div>
    //             </div>

    //             {/* Product count positioned below the image */}
    //             <div className="absolute bottom-0 left-0 right-0 bg-gray-800 text-white text-xs rounded-t-xl p-1 mx-2 text-center">
    //               <span>
    //                 {numberOfProductsOnShelf[item.productId] ?? 0}/
    //                 {numberOfProductsOnPlanogram[item.productId]}/
    //                 {productsCount[item.productId] ?? 0}
    //                 {/* {numberOfProductsOnPlanogram}/ */}
    //                 {console.log(
    //                   "numberOfProductsOnShelf",
    //                   numberOfProductsOnShelf[item.productId]
    //                 )}
    //               </span>
    //             </div>
    //           </div>
    //         ))}
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};
function countNumberOfProductsOnPlanogram(planogram) {
  const productCounts = {};
  // Iterate through the planogram array
  planogram.forEach((item) => {
    const productCount = item.columns * item.depth * item.layers;
    productCounts[item.productId] = productCount;
  });
  return productCounts;
}

function countNumberOfProductsOnShelf(placements) {
  const productLayerCounts = {};

  placements.forEach((item) => {
    item.layers.forEach((layer) => {
      const productId = layer.productId; // Extract productId from layer
      if (productLayerCounts[productId]) {
        productLayerCounts[productId] += 1; // Increment layer count if productId exists
      } else {
        productLayerCounts[productId] = 1; // Otherwise, initialize the count to 1
      }
    });
  });
   return productLayerCounts;
}

export default ShelfView;
